module.exports = __webpack_public_path__ + "images/DownloadingGIF_d01e649.gif";